"use client";

import * as React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function CompareBulls() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="comparebullscta" data-nav="light" className="w-full border-t border-border bg-background py-16 sm:py-20 md:py-24">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: "easeOut"
      }} className="flex flex-col items-center">
          <h2 className="font-serif text-3xl font-bold uppercase tracking-tight text-foreground sm:text-4xl md:text-5xl">
            Compare Mechanical Bulls for Sale
          </h2>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
            Start with the machines currently available, compare the complete equipment package and use the individual product information rather than generic specifications. When you find a bull that fits your needs, send the exact product through our Request a Quote form.
          </p>

          <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row sm:flex-wrap sm:gap-4">
            <Button asChild size="lg" variant="outline" className="w-full sm:w-auto rounded-lg border-foreground bg-transparent px-6 py-3 font-semibold uppercase tracking-wider text-foreground hover:bg-foreground hover:text-background transition-colors">
              <Link to="/NewMechanicalBullsPage">
                VIEW NEW BULLS
              </Link>
            </Button>

            <Button asChild size="lg" variant="outline" className="w-full sm:w-auto rounded-lg border-foreground bg-transparent px-6 py-3 font-semibold uppercase tracking-wider text-foreground hover:bg-foreground hover:text-background transition-colors">
              <Link to="/UsedMechanicalBullsPage">
                VIEW USED BULLS
              </Link>
            </Button>

            <Button asChild size="lg" className="w-full sm:w-auto rounded-lg border border-primary bg-primary px-6 py-3 font-semibold uppercase tracking-wider text-primary-foreground hover:brightness-95 transition-[filter]">
              <Link to="/RequestQuotePage">
                REQUEST A QUOTE
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}